export const capitalizeString = (word: string) =>
  word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : '';
